module.exports = __webpack_public_path__ + "img/email.8f2561c7.svg";